// Copyright (c) 2016 Deere & Company

import 'babel-core/polyfill';
import './index.scss';
import {checkForIframe, initOkta} from './shared/services/okta';
import React from 'react';
import WarrantyProvider from './warranty-provider';
import {getStore} from './store-factory';
import {getUserSecurity} from './user/shared/repositories';
import {readSapStatus} from './app/action-creators/sap-status';
import {render} from 'react-dom';
import {setAppConfig} from './app-config/action-creators';

(async() => {

    const store = getStore();

    try {

        await setAppConfig(store);
        await initOkta();
        await checkForIframe();
        await readSapStatus(store);
        await getUserSecurity(store);

        render(
            <WarrantyProvider
                store={store}
            />,
            document.querySelector('.content')
        );

    } catch (error) {
    }

})();



// WEBPACK FOOTER //
// ./src/index.js